<template>
  <div class="app-container">
    <BjRouteTabs />
    <PageOrdinaryPackage :set-flag="GOODS_COMBO_TYPES.PACKAGE" />
  </div>
</template>
<script>
import PageOrdinaryPackage from '../componentsCSG/PageOrdinaryPackage.vue';
import { GOODS_COMBO_TYPES } from '@/utils/constants';
export default {
  name: 'BusinessGoodsAuditSkuPackageCSGIndex',
  components: {
    PageOrdinaryPackage,
  },
  data() {
    return {
      GOODS_COMBO_TYPES,
    };
  },
};
</script>

<style scoped>
::v-deep .bj-page .el-form-item__label{
  display: none;
}
</style>